import CustomTable, { StyledTableCell } from "@/components/Table/CustomTable";
import { Box } from "@mui/material";
import * as React from "react";
import { ListItem } from "../beeswaxList.interface";
import { listItemsTableHeaders } from "../data";

export default function ListItemsTable({
  data,
}: {
  data: ListItem[];
}): ReturnType<React.FC> {
  return (
    <Box>
      <Box sx={{ width: "100%" }}>
        <CustomTable<ListItem>
          headers={listItemsTableHeaders}
          rowData={data ?? []}
          tableRowComponent={ListItemsTableRows}
          isLoading={false}
          showButton={false}
          pagination={false}
          disableShadow
        />
      </Box>
    </Box>
  );
}

function ListItemsTableRows({ row }: { row: ListItem }) {
  return (
    <>
      <StyledTableCell align="left">{row?.list_item_id}</StyledTableCell>
      <StyledTableCell align="left">{row?.list_item}</StyledTableCell>
      <StyledTableCell align="left">{row?.value}</StyledTableCell>
      <StyledTableCell align="left">{row?.list_item_name}</StyledTableCell>
    </>
  );
}
